import React from 'react'
import hard1 from '../../assets/images/hard1.svg'
import hard2 from '../../assets/images/hard2.svg'
import hard3 from '../../assets/images/hard3.svg'
import hard4 from '../../assets/images/hard4.svg'
import hard5 from '../../assets/images/hard5.svg'
import and from '../../assets/images/and.svg'

const HardwareBanner = () => {
    return (
        <div className='hardware-banner'>
            <div className='content'>
                <div className='title'><h1>HARDWARE</h1></div>
                <div className='hards'>
                    <div><img src={hard1} alt='' /></div>
                    <div><img src={hard2} alt='' /></div>
                    <div><img src={hard3} alt='' /></div>
                    <div><img src={hard4} alt='' /></div>
                    <div><img src={hard5} alt='' /></div>
                </div>
                <div className='and'><img src={and} alt='' /></div>
                <div className='and-more'><h3>AND MORE</h3></div>
                <div className='description'>
                    <div className='text1'><span>In today’s business world, a robust IT infrastructure and reliable systems are critical to the success of enterprises. Liberyus provides corporate technology solutions and is an authorized reseller of globally recognized brands.</span></div>
                    <div className='text2'><span>By integrating the latest technologies from industry-leading brands into your business, we ensure efficiency, security, and scalability.</span></div>
                </div>
            </div>
        </div>
    )
}

export default HardwareBanner
